import * as RadixCollapsible from '@radix-ui/react-collapsible'
import { keyframes, styled } from 'styled-components'

const slideDown = keyframes`
  from {
    height: 0;
  }
  to {
    height: var(--radix-collapsible-content-height);
  }
`

const slideUp = keyframes`
  from {
    height: var(--radix-collapsible-content-height);
  }
  to {
    height: 0;
  }
`

export const CollapsibleRoot = styled(RadixCollapsible.Root)``

export const Collapsible = styled(RadixCollapsible.Content).attrs<{ $duration?: string }>(props => ({
  $duration: props.$duration || '200ms',
}))`
  overflow: hidden;
  will-change: height;

  &[data-state='open'] {
    animation: ${slideDown} ease-out;
    animation-duration: ${props => props.$duration};

    @media (prefers-reduced-motion) {
      animation: none;
    }
  }

  &[data-state='closed'] {
    animation: ${slideUp} ease-out;
    animation-duration: ${props => props.$duration};

    @media (prefers-reduced-motion) {
      animation: none;
    }
  }
`

export const CollapsibleTrigger = styled(RadixCollapsible.Trigger)``
